import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import React from 'react';
import Home from './components/home';
import Collections from './components/collections';
import Collection from './components/collection';
import Contract from './components/contract';
import Process from './components/process';
import ProcessList from './components/process-list';
import Login from './components/login';
import AuthCookies from './components/auth-cookies';
import Withdraw from './components/withdraw';
import NotFound from './components/not-found';
import Deposit from './components/deposit';
import DataGraph from './components/datagraph';
import ContractStatus from "./components/contract-status";
import TransactionList from "./components/transaction-list";
import Asset from "./components/asset";
import UserCards from "./components/user-cards";
import Assets from "./components/assets";
import TokenBinding from "./components/token-binding";

function Routes() {
    const {getAuthCookie} = AuthCookies();
    const token = getAuthCookie();

    if (token && token !== 'undefined') {
        return (
            <Router>
                <Switch>
                    <Route exact path="/" component={Home}/>
                    <Route path="/login" component={Login}/>
                    <Route path="/collections" component={Collections}/>
                    <Route path="/collection" component={Collection}/>
                    <Route path="/contract" component={Contract}/>
                    <Route path="/processes/all" component={ProcessList}/>
                    <Route path="/jetski/process/" component={Process}/>
                    <Route path="/withdraw/" component={Withdraw}/>
                    <Route path="/deposit/" component={Deposit}/>
                    <Route path="/datagraph/" component={DataGraph}/>
                    <Route path="/transactions/" component={TransactionList}/>
                    <Route path="/contracts/status/" component={ContractStatus}/>
                    <Route path="/asset/" component={Asset}/>
                    <Route path="/diagnose/cards" component={UserCards}/>
                    <Route path="/diagnose/assets" component={Assets}/>
                    <Route path="/diagnose/token" component={TokenBinding}/>
                    <Route component={NotFound}/>
                </Switch>
            </Router>
        );
    }

    return <Login/>;
}

export default Routes;
